import React from "react";

const SvgDragAndDrop = props => (
  <svg viewBox="0 0 91 196" {...props}>
    <g data-name="Vrstva 2">
      <g data-name="Global report">
        <g data-name="Drag and drop">
          <path data-name="&lt;\u0158ez&gt;" fill="none" d="M0 0h91v196H0z" />
          <path d="M4.46 16A13.65 13.65 0 1118.1 29.68 13.64 13.64 0 014.46 16zM59 16a13.64 13.64 0 1113.67 13.68A13.64 13.64 0 0159 16zM4.46 70.61A13.65 13.65 0 1118.1 84.25 13.64 13.64 0 014.46 70.61zM59 70.61a13.64 13.64 0 1113.67 13.64A13.64 13.64 0 0159 70.61zM4.46 125.18a13.65 13.65 0 1113.64 13.64 13.64 13.64 0 01-13.64-13.64zM59 125.18a13.64 13.64 0 1113.64 13.64A13.64 13.64 0 0159 125.18zM4.46 179.75a13.65 13.65 0 1113.64 13.64 13.65 13.65 0 01-13.64-13.64zM59 179.75a13.64 13.64 0 1113.64 13.64A13.65 13.65 0 0159 179.75z" />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgDragAndDrop;
